import React, { Component, useState } from 'react';
import RegisterEmailView from './RegisterEmailView';
import ReceiveMarketingEmailView from './ReceiveMarketingEmailView'
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import crmServices from '../../wsclient/crmservices'
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert'
import Loading from '../../components/Loading'
import {getAppCfg, getBrowser, getCountries, getCountryDefault, getRejectTriggerContact, getSupportOrderLocation, setSupportOrderContact} from '../../utils/common'
import { Grid } from '@material-ui/core';
import { LinkCTA, LinkInLine, LinkRouter } from '../../components/Link';
import { countries_agreement } from '../../../portal.menu.config';
import { isThisHour } from 'date-fns/esm';
import { isThisSecond } from 'date-fns';
import RegisterVerificationView from '../register/RegisterVerificationView';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
const styles = theme => ({

});
function RegisterEmail(props){
    const config = getAppCfg()
    let agreement_countries = config&&config.contact&&config.contact.agreement_countries?config.contact.agreement_countries:null
    let country_default = getCountryDefault(agreement_countries)?getCountryDefault(agreement_countries): null;

    const [active, setActive] = useState('main');
    const [error, setError] = useState({});
    const [showLoading, onShowLoading] = useState(false);
    const [register_info, setRegisterInfo] = useState({
                                                        email_opt_out: false,
                                                        sms_opt_out: false,
                                                        country_agreement: country_default ? country_default.value: null
                                            });
    const [auth_otp, setAuthOtp] = useState(null);
    const [obfuscated_value, setObfuscatedValue] = useState(null);
    const [validation, setValiadation] = useState({});
    const [countDown, setCountDown] = useState('');
    const [timer_otp, setTimeOTP] = useState({});
    const [accept_policy, setAcceptPolicy] = useState(false);
    const [redirect, setRedirect] = useState(null);                                        
    const auth_support = config && config.auth_support ? config.auth_support: {facebook:false, google:false};
    const requestTimer = 30;     

    const onSelectCountry = (values) => {
        setRegisterInfo(prevState => ({
            ...prevState,
            country_agreement: values.target.value
        }));
    }
    const  onRegister = async(values) => {
        let temp_register_info = {...register_info}
        setRegisterInfo(prevState => ({
            ...prevState,
            first_name: values.first_name,
            last_name: values.last_name,
            username: values.username,
            password: values.password,
            referral_code: values.referral_code
        }));
        temp_register_info.first_name = values.first_name;
        temp_register_info.last_name = values.last_name;
        temp_register_info.username = values.username;
        temp_register_info.password = values.password;
        temp_register_info.referral_code = values.referral_code;
        
        if (values.password!==values.confirm_password){
            showAlert(t('ERROR'), t('ENTER_THE_SAME_PASSWORD'));
            return
        }
        onShowLoading(true);
        let appConfig = getAppCfg();
        let isEmailOtp = appConfig && appConfig.auth_support && appConfig.auth_support.email_otp;
            try {
                let validation_required = appConfig.auth_support &&  appConfig.auth_support.email_verification ? true : false;  
                if(isEmailOtp)
                    validation_required = undefined;

                let result = await crmServices.contacts.registerByEmail({ ...temp_register_info, validation_required: validation_required });
                //console.log('onRegister result====', result)
                if (result.code == 'OK') {
                    if(validation_required){
                        showAlert('SUCCESS', t('REGISTER_EMAIL_SUCCESS'),null,"/login", true);
                    }else if(isEmailOtp){
                        setActive('verify');
                        setAuthOtp(result.data.auth_otp);
                        setObfuscatedValue(result.data.obfuscated_value);
                    }else{
                        if(result.data.access_token){
                            await crmServices.startSession(result.data);
                            //crmServices.contacts.addApplicationUsage(appConfig.id,getBrowser().toUpperCase());
                            props.history.push('/home');
                        }else{
                            showAlert('SUCCESS', t('REGISTER_EMAIL_SUCCESS'));
                        }
                    }
                    //this.props.history.push('/login');
                } else if (result.code === 'REGISTRATION_FAIL_CONTACT_EXISTS') {
                    showAlert('ERROR', t('REGISTRATION_FAIL_CONTACT_EXISTS_EMAIL'));
                }else if (result.code === 'INVALID_PASSWORD_EXCEPTION') {
                    showAlert('ERROR', t('INVALID_PASSWORD_EXCEPTION'));
                }else if (result.code === 'PASSWORD_LENGTH_EXCEPTION') {
                    showAlert('ERROR', t('PASSWORD_LENGTH_EXCEPTION'));
                } else {
                    showAlert('ERROR', t(result.code));
                }
            } catch (error) {
                console.log("register by email exception:", error);
                showAlert('ERROR', t('EXCEPTION_PROCESS'))
            }
            onShowLoading(false);
    }
    const onVerifyOTP = async (code) => {
        onShowLoading(true);
        try {
            let config = getAppCfg();
            let result = await crmServices.contacts.validateOTP({ phone: null, auth_otp: auth_otp, otp: code.verification_code });
            if (result.code === 'OK') {
                //crmServices.contacts.addApplicationUsage(config.id,getBrowser().toUpperCase());
                onShowLoading(false);
                setActive('receive_marketing');
                if(!getSupportOrderLocation()&&!getRejectTriggerContact()){
                    
                    let ordering_countries = []
                    if(config.features && config.features.ordering&&config.features.ordering_details&&config.features.ordering_details.ordering_countries){
                        ordering_countries = config.features.ordering_details.ordering_countries
                    }
                    let isAllowOrder = await dataUtil.checkAllowOrderByContact(ordering_countries);
                    if(isAllowOrder){
                        setSupportOrderContact(true)
                    }
                }

                props.history.push('/home');
            } else {
                showAlert('ERROR', t('INVALID_OTP'))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false);
    }
    const onResendCode = async () => {
        onShowLoading(true);
        try {
            let startSession = false;
            let result = await crmServices.contacts.authenticateEmail({username:register_info['username'] },startSession);
            //console.log("AAAAAAA result:",result);
            if (result.code === 'OK') {
                if (result.data && result.data.auth_otp) {
                    setAuthOtp(result.data.auth_otp);
                }
                showAlert('SUCCESS', t('OTP_RESEND_SUCCESS'), t('OTP'))
               // this.beginCountDown();
            } else {
                showAlert('ERROR', t('EXCEPTION_PROCESS'), t('OTP'))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'), t('OTP'))
        }
        onShowLoading(false);
    }
    const onReceiveMarketing = (target, value) => {
        setRegisterInfo(prevState => ({
            ...prevState,
            [target]: value
        }));
    }
    const showAlert = (status, message, title, redirect, children) => {
        onShowLoading(false);
        setRedirect(redirect);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status,
            children: children
        });
    }
    const onCloseAlert = () => {
        if(redirect==='/login'){
            props.history.push('/login');
        }
        onShowLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
        });
    }
    const onChangeCheckboxPolicy = () => {
        setAcceptPolicy(!accept_policy);
    }
    const onResendVerification = async () => {
        //console.log(' login_info===',login_info)
        if (!register_info&&!register_info.username){
            return;
        }
        onShowLoading(true);
        
        try {
            let result = await crmServices.contacts.sendEmailVerification(register_info.username);
            //console.log("AAAAAAA result:",result);
            if (result.code === 'OK') {
                showAlert('SUCCESS', t('RESEND_EMAIL_SUCCESS'), t('OTP'), '/login')
            } else if(result.code=='TOO_MANY_REQUESTS'){
                showAlert(t('ERROR'), t('TOO_MANY_REQUESTS'));
            } else if(result.code=='TOO_MANY_RECIPIENTS_EXCEPTION'){
                showAlert(t('ERROR'), t('TOO_MANY_RECIPIENTS_EXCEPTION'));
            } else {
                showAlert('ERROR', t('EXCEPTION_PROCESS'), t('OTP'))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'), t('OTP'))
        }
        onShowLoading(false)
    }
    const renderPage = (active) => {
       // console.log('RegisterEmail accept_policy==',accept_policy)
        if(active==='main')
            return(
                <RegisterEmailView
                onSubmit={onRegister}
                showAlert={showAlert}
                onShowLoading={onShowLoading}
                onReceiveMarketing = {onReceiveMarketing}
                register_info = {register_info}
                auth_support = {auth_support}
                country_default = {country_default}
                onSelectCountry = {onSelectCountry}
                onChangeCheckboxPolicy={onChangeCheckboxPolicy}
                accept_policy={accept_policy}/>
            )         
        else if(active==='verify')        
            return(
                <RegisterVerificationView
                onSubmit={onVerifyOTP}
                onResend={onResendCode}
                obfuscated_value={obfuscated_value}
                countDown={countDown}/>
            )

    }
    let page = renderPage(active);
    return (
        <div>
        {page}
        <ModalAlert
            open={error.showAlert}
            onClose={onCloseAlert}
            hideHeader={true}
            message={error.message}
            error={error.status}
            title={error.title}
            children={error.children&&<Grid xs={12} item container justify='center' style={{marginTop:16}}>
                    <LinkCTA color='primary' underline
                        onClick={onResendVerification}>
                        {t('resend_verification_email')}
                    </LinkCTA>
                </Grid>
                }
        />
        {showLoading && <Loading showLoading={showLoading} />}
        </div>

    );
}
export default withStyles(styles)(withTranslation()(RegisterEmail));